import { useMutation, useQuery, useQueryClient } from 'react-query';
import OneAuthAPI from 'services/API/OneAuthAPI';

export const ONE_PROVISION_STATUS_QUERY_KEY = 'one-provision-status';

const DEFAULT_STATUS = {
  provisioned: false,
  organization_pid: null,
  project_pid: null,
};

/**
 * Whether the current user has a provisioned One workspace (org + project).
 */
export const useOneProvisionStatus = (enabled = true) => {
  return useQuery(
    [ONE_PROVISION_STATUS_QUERY_KEY],
    async () => {
      const result = await OneAuthAPI.getProvisionStatus();

      return result?.data ?? DEFAULT_STATUS;
    },
    {
      enabled,
      // Provision status doesn't change during a session (only when the user
      // provisions One), so fetch it once and reuse the cache across pages.
      // useProvisionOne invalidates this key when it actually changes.
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};

/**
 * Provisions the current user's One organization + project, then refreshes the
 * provision status on success.
 */
export const useProvisionOne = () => {
  const queryClient = useQueryClient();

  return useMutation(() => OneAuthAPI.provision(), {
    onSuccess: () => {
      queryClient.invalidateQueries([ONE_PROVISION_STATUS_QUERY_KEY]);
    },
  });
};
